import PropTypes from 'prop-types';

export const IdentityProvider = PropTypes.shape({
  created_time: PropTypes.string,
  email_attribute: PropTypes.string,
  entity_id: PropTypes.string,
  first_name_attribute: PropTypes.string,
  id: PropTypes.string,
  id_attribute: PropTypes.string,
  last_name_attribute: PropTypes.string,
  metadata: PropTypes.string,
  name: PropTypes.string,
  required_attributes: PropTypes.object,
  updated_time: PropTypes.string
});
